import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ResponseData } from '../models/interfaces/common';
import { Permission } from '../models/interfaces/permission';
import { PERMISSIONS_ENUM } from '../enum/permission.enum';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private httpClient: HttpClient) {}

  getRoles() {
    return this.httpClient.get<ResponseData<Permission[]>>(
      `${environment.BE_URL}user/admin/roles/module`,
    );
  }

  getPermissions() {
    return this.httpClient.get<ResponseData<PERMISSIONS_ENUM[]>>(
      `${environment.BE_URL}user/admin-permissions/hub/SHOP_MODULE_ADMIN/permission`,
    );
  }

  getPermissionsByModule(moduleType: string) {
    return this.httpClient.get<ResponseData<string[]>>(
      `${environment.BE_URL}user/admin-permissions/hub/${moduleType}/permission`,
    );
  }
}
